import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollListPerquisiteComponentAssignmentsQueryVariables,
  PayrollListPerquisiteComponentAssignmentsResponse,
} from './types';

export const listPerquisiteComponentAssignmentsQuery = gql`
  query PayrollListPerquisiteComponentAssignments(
    $input: ListPerquisiteComponentAssignmentsInput!
  ) {
    payrollListPerquisiteComponentAssignments(input: $input) {
      code
      message
      success
      data {
        id
        userId
        componentId
        componentSource
        componentName
        totalAmount
        amountAlreadyPaid
        includeInCompensation
        includeInPayroll
      }
    }
  }
`;

const listPerquisiteComponentAssignments = (
  queryVariables: PayrollListPerquisiteComponentAssignmentsQueryVariables,
) => {
  return graphQLApi<
    PayrollListPerquisiteComponentAssignmentsResponse,
    PayrollListPerquisiteComponentAssignmentsQueryVariables
  >({
    query: listPerquisiteComponentAssignmentsQuery,
    queryVariables,
  });
};

export default listPerquisiteComponentAssignments;
